import { render, staticRenderFns } from "./ColorContrastMixin.js.vue?vue&type=template&id=0b413c3c&scoped=true&"
import script from "./ColorContrastMixin.js.vue?vue&type=script&lang=js&"
export * from "./ColorContrastMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b413c3c",
  null
  
)

export default component.exports